import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@ui/card.tsx';
import { Send } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useContext } from 'react';
import { WorkspaceConfigContext } from '@r/context/workspace-config-context.ts';
import defaultLogo from '@r/assets/images/fiddy/logo.svg';
import { FirstLoginForm } from '@r/components/auth/first-login-form.tsx';

type FirstLoginData = {
  success: boolean;
};

export const FirstLoginPage = () => {
  const { t } = useTranslation();
  const workspaceConfigContext = useContext(WorkspaceConfigContext);

  // stockage du first login pour éviter de la répéter
  const firstLoginQuery = useQuery<FirstLoginData>({
    queryKey: ['first_login'],
    queryFn: () => Promise.resolve(undefined as unknown as FirstLoginData),
    enabled: false,
    staleTime: 0,
    gcTime: 0
  });

  if (firstLoginQuery.data) {
    return (
      <div className="container flex flex-col pt-8 grow">
        <div className="flex w-full max-w-[100%] flex-grow items-center sm:w-[32rem]">
          <Card className="w-[32rem] rounded-[30px] p-16">
            <CardHeader className="p-0 text-center">
              <img
                src={workspaceConfigContext?.groupedConfigs?.media?.logo || defaultLogo}
                className="object-contain object-center px-6 m-auto w-full xs:w-10/12 sm:w-8/12 md:w-7/12"
                alt="logo"
              />

              <div className="flex justify-center mt-8">
                <Send className="w-16 h-auto stroke-foreground" />
              </div>

              <CardDescription className="mt-8 text-sm font-light text-center text-muted-foreground">
                {t('first.login.success.description')}
                <br />
                {t('first.login.success.spam')}
              </CardDescription>
            </CardHeader>

            <CardContent className="p-0 mt-12 text-center">
              <Link
                to="/login"
                className="text-sm font-light underline underline-offset-4 hover:text-foreground"
              >
                {t('first.login.back.login')}
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  return (
    <div className="container flex flex-col pt-8 grow">
      <div className="flex w-full max-w-[100%] flex-grow items-center sm:w-[32rem]">
        <Card className="w-[32rem] rounded-[30px] p-16">
          <CardHeader className="p-0 text-center">
            <img
              src={workspaceConfigContext?.groupedConfigs?.media?.logo || defaultLogo}
              className="object-contain object-center px-6 m-auto w-full xs:w-10/12 sm:w-8/12 md:w-7/12"
              alt="logo"
            />

            <CardTitle className="mt-8 break-words text-center font-author-complete font-regular text-[2rem] leading-[3rem] sm:text-[2.3rem]">
              {t('first.login.title')}
            </CardTitle>

            <CardDescription className="text-sm font-light text-center text-muted-foreground">
              {t('first.login.description')}
            </CardDescription>
          </CardHeader>

          <CardContent className="p-0 mt-12 space-y-8">
            <FirstLoginForm />

            <p className="text-sm text-center text-muted-foreground">
              <Link
                to="/login"
                className="font-light underline underline-offset-4 hover:text-foreground"
              >
                {t('first.login.back.login')}
              </Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
